import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import apiConfig from './url'
import {Indicator, Toast } from 'mint-ui';

export default  function request(prop,method, url, params, successBack, errorBack,cmd) {
	cmd&&cmd()
	Indicator.open({
		text:'加载中...',
		spinnerType:'fading-circle'
	})
	axios[method](apiConfig.baseURL + url, params)
		.then((response) => {
			Indicator.close();
			if(eval("response"+prop) == 0) {
				successBack(response)
			} else {
				Toast({
				  message: response.message,
				  position: 'bottom',
				  duration:3000
				});
				errorBack && errorBack(response)
			}
		})
		.catch((reject) => {
			Indicator.close();
			console.error('dwada',reject)
		});
}

	
// http response 服务器响应拦截器，在成功回调中将token的过期时间重新设置在30分钟后，err回调这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
	success => {
		return success.data
	},
	error => {
		if(error.response) {
			let path = router.currentRoute.fullPath;
			if(router.currentRoute.meta.noNeedLogin) {
				return Promise.reject({
					code: 0
				})
			} else {
				if(error.response.status == 401 || error.response.status == 409) {
					if(path.indexOf("redirect") == -1 && path.indexOf("login") == -1) {
						router.replace({
							path: '/login',
							query: {
								redirect: path
							} //登录成功后跳入浏览的当前页面
						})
					}
				}
			}
		}
		return Promise.reject(error)
	}
);




// WEBPACK FOOTER //
// ./src/service/request.js